module.exports = "https://www.gc-qa.gnp.com.mx/33645adac5441af002ded11a10d8ab7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/07-finiquitos.svg
// module id = 8040
// module chunks = 0